// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { NormalisedLayerType } from "./NormalisedLayerType";
import {
  NormalisedLayerTypeFromJSON,
  NormalisedLayerTypeFromJSONTyped,
  NormalisedLayerTypeToJSON,
  NormalisedLayerTypeToJSONTyped,
} from "./NormalisedLayerType";

/**
 * Normalised layer description exposed by every data type that contains layers.
 * @export
 * @interface NormalisedLayer
 */
export interface NormalisedLayer {
  /**
   *
   */
  id: string;
  /**
   *
   */
  name: string;
  /**
   *
   */
  type?: NormalisedLayerType | null;
}

/**
 * Check if a given object implements the NormalisedLayer interface.
 */
export function instanceOfNormalisedLayer(value: object): value is NormalisedLayer {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function NormalisedLayerFromJSON(json: any): NormalisedLayer {
  return NormalisedLayerFromJSONTyped(json, false);
}

export function NormalisedLayerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): NormalisedLayer {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
    type:
      json["type"] === undefined
        ? undefined
        : json["type"] === null
        ? null
        : NormalisedLayerTypeFromJSON(json["type"]),
  };
}

export function NormalisedLayerToJSON(json: any): NormalisedLayer {
  return NormalisedLayerToJSONTyped(json, false);
}

export function NormalisedLayerToJSONTyped(
  value?: NormalisedLayer | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    name: value["name"],
    type: NormalisedLayerTypeToJSON(value["type"]),
  };
}
